var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _g2, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgThink = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#think_svg__clip0_722_819)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#think_svg__filter0_iii_722_819)",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.177 1.036c10.752 0 19.469 8.717 19.469 19.47 0 10.752-8.717 19.468-19.469 19.468S.708 31.258.708 20.505c0-10.752 8.717-19.469 19.469-19.469z",
  fill: "#FFEE40"
})), /*#__PURE__*/React.createElement("path", {
  d: "M20.177 1.036c10.752 0 19.469 8.717 19.469 19.47 0 10.752-8.717 19.468-19.469 19.468S.708 31.258.708 20.505c0-10.752 8.717-19.469 19.469-19.469z",
  fill: "url(#think_svg__paint0_linear_722_819)",
  style: {
    mixBlendMode: "overlay"
  }
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.177 2.806c9.775 0 17.699 8.24 17.699 18.407 0 10.166-7.924 18.407-17.7 18.407-9.774 0-17.698-8.241-17.698-18.407S10.402 2.806 20.177 2.806z",
  fill: "url(#think_svg__paint1_linear_722_819)"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.177 2.806c9.775 0 17.699 8.24 17.699 18.407 0 10.166-7.924 18.407-17.7 18.407-9.774 0-17.698-8.241-17.698-18.407S10.402 2.806 20.177 2.806z",
  fill: "url(#think_svg__paint2_linear_722_819)",
  style: {
    mixBlendMode: "overlay"
  }
}), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.468 16.815h1.063V12.92h-1.063v3.894z",
  fill: "#000",
  stroke: "#000",
  strokeWidth: 0.354
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M37.07 38.407s-1.464-2.13-1.77-5.31c-.306-3.18.997-6.628 1.12-10.654.121-4.025-1.397-7.4-2.89-7.4",
  stroke: "#000",
  strokeWidth: 0.354
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#think_svg__filter1_dii_722_819)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.495 7.964s1.094-.544 1.77-.708c.892-.216 1.948-1.046 3.185-1.062.926-.011 2.58.8 2.832 1.416.169.41 0 1.062 0 1.062s-1.638-.867-2.349-.867c-.71 0-1.883-.263-2.992 0-1.11.262-2.288 1.043-2.288 1.043s-.179.33-.512-.176c-.334-.505.354-.708.354-.708z",
  fill: "#A66707"
}))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M25.389 7.61a7.08 7.08 0 110 14.16 7.08 7.08 0 010-14.16z",
  stroke: "#000",
  strokeWidth: 0.354
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.742 8.319c3.715 0 6.726 3.09 6.726 6.902 0 3.813-3.011 6.903-6.726 6.903-3.714 0-6.725-3.09-6.725-6.902 0-3.813 3.01-6.903 6.725-6.903z",
  fill: "url(#think_svg__paint3_linear_722_819)"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.742 8.319c3.715 0 6.726 3.09 6.726 6.902 0 3.813-3.011 6.903-6.726 6.903-3.714 0-6.725-3.09-6.725-6.902 0-3.813 3.01-6.903 6.725-6.903z",
  fill: "url(#think_svg__paint4_linear_722_819)",
  style: {
    mixBlendMode: "overlay"
  }
}), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M25.389 7.61a7.08 7.08 0 110 14.16 7.08 7.08 0 010-14.16z",
  stroke: "#000",
  strokeWidth: 0.354
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#think_svg__filter2_dii_722_819)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.776 11.52c.996.222 1.535 1.613 1.202 3.108-.332 1.495-1.41 2.526-2.406 2.305-.997-.221-1.535-1.613-1.202-3.108.332-1.494 1.41-2.526 2.406-2.305z",
  fill: "#A66707"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#think_svg__filter3_dii_722_819)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.062 12.581c1.027.2 1.616 1.61 1.316 3.149-.299 1.54-1.374 2.625-2.4 2.426-1.026-.2-1.615-1.61-1.316-3.149.3-1.54 1.374-2.625 2.4-2.426z",
  fill: "#A66707"
}))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#think_svg__filter4_dii_722_819)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.813 10.443c.53-.17.938-.708 1.77-.708.832 0 3.376 1.062 4.248 1.062.873 0 1.416.044 1.416-.354 0-.398-.239-.641-.708-.708-.469-.067-1.936-.395-2.478-.708-.542-.314-1.414-.708-2.124-.708-.71 0-2.126.591-2.832 1.062-.705.47-.604.81-.354 1.062.251.25.533.17 1.062 0z",
  fill: "#A66707"
}))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#think_svg__filter5_dii_722_819)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.174 25.183c.27 0 4.773-.439 7.039 0 2.265.439 3.15 1.329 3.458 1.543.307.214 0 .604-.596.45-.596-.155-1.831-1.585-5.649-1.474-3.817.11-3.846.069-4.252.069-.405 0-.269-.588 0-.588z",
  fill: "#A66707"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "think_svg__filter0_iii_722_819",
  x: 0.708,
  y: -7.813,
  width: 38.938,
  height: 47.788,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -8.85
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10.62
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 0.603922 0 0 0 0 0 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_722_819"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -2.832
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.655
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.65098 0 0 0 0 0.403922 0 0 0 0 0.027451 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_innerShadow_722_819",
  result: "effect2_innerShadow_722_819"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.354
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.709804 0 0 0 0 0.364706 0 0 0 0 0.0196078 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect2_innerShadow_722_819",
  result: "effect3_innerShadow_722_819"
})), /*#__PURE__*/React.createElement("filter", {
  id: "think_svg__filter1_dii_722_819",
  x: 20.695,
  y: 6.194,
  width: 9.016,
  height: 3.467,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.354
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.177
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_722_819"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_722_819",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.708
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.814
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect2_innerShadow_722_819"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.531
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect2_innerShadow_722_819",
  result: "effect3_innerShadow_722_819"
})), /*#__PURE__*/React.createElement("filter", {
  id: "think_svg__filter2_dii_722_819",
  x: 10.918,
  y: 11.49,
  width: 4.513,
  height: 6.181,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.354
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.177
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_722_819"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_722_819",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.708
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.814
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect2_innerShadow_722_819"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.531
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect2_innerShadow_722_819",
  result: "effect3_innerShadow_722_819"
})), /*#__PURE__*/React.createElement("filter", {
  id: "think_svg__filter3_dii_722_819",
  x: 22.23,
  y: 12.558,
  width: 4.58,
  height: 6.33,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.354
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.177
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_722_819"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_722_819",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.708
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.814
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect2_innerShadow_722_819"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.531
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect2_innerShadow_722_819",
  result: "effect3_innerShadow_722_819"
})), /*#__PURE__*/React.createElement("filter", {
  id: "think_svg__filter4_dii_722_819",
  x: 8.209,
  y: 8.319,
  width: 9.392,
  height: 3.187,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.354
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.177
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_722_819"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_722_819",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.708
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.814
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect2_innerShadow_722_819"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.531
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect2_innerShadow_722_819",
  result: "effect3_innerShadow_722_819"
})), /*#__PURE__*/React.createElement("filter", {
  id: "think_svg__filter5_dii_722_819",
  x: 12.565,
  y: 24.988,
  width: 11.581,
  height: 2.931,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.354
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.177
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_722_819"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_722_819",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.708
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.814
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect2_innerShadow_722_819"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.531
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect2_innerShadow_722_819",
  result: "effect3_innerShadow_722_819"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "think_svg__paint0_linear_722_819",
  x1: 40,
  y1: 40.328,
  x2: 40,
  y2: 0.328,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.01
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "think_svg__paint1_linear_722_819",
  x1: 32.817,
  y1: 11.594,
  x2: 32.817,
  y2: -14.415,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.01
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "think_svg__paint2_linear_722_819",
  x1: 10.973,
  y1: 2.098,
  x2: 10.973,
  y2: 21.036,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0.01
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "think_svg__paint3_linear_722_819",
  x1: 30.361,
  y1: 11.78,
  x2: 30.361,
  y2: 2.3,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.01
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "think_svg__paint4_linear_722_819",
  x1: 22.379,
  y1: 8.319,
  x2: 22.379,
  y2: 15.222,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0.01
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "think_svg__clip0_722_819"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h40v40H0z"
})))));
export default "data:image/svg+xml;base64,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";
export { SvgThink as ReactComponent };